const { can } = require("./can");

const hasPermission = (permissionName, subjectInstance = null, user) => {
  const permissionEntry = permissions[permissionName];
  if (permissionEntry) {
    const [action, subjectType] = permissionEntry;
    return can(user, action, subjectType, subjectInstance);
  }
  return false;
};

const permissions = {
  canCreateOrder: ["create", "order"],
  canCreateCustomer: ["create", "company"],
  canUpdateCustomer: ["update", "company"],
  canReadCustomerPricing: ["read", "customer-pricing"],
  canUpdateCustomerPricing: ["update", "customer-pricing"],
  canCreateDistributor: ["create", "distributor"],
  canUpdateDistributor: ["update", "distributor"],
  canUpdateProduct: ["update", "product"],
  canReadEmailSetting: ["read", "email-setting"],
  canUpdateEmailSetting: ["update", "email-setting"],
  canInviteAssociate: ["invite", "associate"],
  canUpdateAssociate: ["update", "associate"],
  canInviteUser: ["invite", "user"],
  canUpdateUser: ["update", "user"],
  canReadDistributor: ["read", "distributor"],
  canCreateProduct: ["create", "product"],
  canReadAssociate: ["read", "associate"],
  canReadCustomer: ["read", "company"],
  canSubmitOrder: ["submit", "order"],
  canUpdateOrderStatus: ["update", "order-status"],
  canReadPermission: ["read", "permission"],
  canDeleteProduct: ["delete", "product"],
  canUploadProduct: ["upload", "product"],
  canReadRole: ["read", "role"],
  canUpdateRole: ["update", "role"],
  canCreateRole: ["create", "role"],
  canReadProduct: ["read", "product"],
  canReadOrder: ["read", "order"],
  canReadSpecificCustomer: ["read", "company"],
  canReadAssignedCustomerOrders: ["read", "order"],
  canReadFinancials: ["read", "financials"],
};

module.exports = {
  hasPermission,
};
